import DropzoneWrapper from './DropzoneWrapper';

export default DropzoneWrapper;
